module.exports = __webpack_public_path__ + "img/ring_y_e_null_null.c6876779.png";